import { createSlice } from '@reduxjs/toolkit';

const productSlice = createSlice({
    name: 'products',
    initialState: {
        items: [],
        loading: false,
        error: null,
    },
    reducers: {
        setProductsLoading: (state) => {
            state.loading = true;
        },
        setProductsSuccess: (state, action) => {
            state.loading = false;
            state.items = action.payload;
        },
        setProductsError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { setProductsLoading, setProductsSuccess, setProductsError } = productSlice.actions;
export default productSlice.reducer;